export enum ContentTypeEnum {
    HEADER = 'header',
    HEADER_LINK = 'headerLink',
    HOME = 'home',
    CUSTOMER = 'customer',
    TECHNOLOGY = 'technology',
    ABOUT_US = 'about-us',
}
